<template>
  <a href="/Search/Index" :title="$t('Search')" class="search-float-btn" target="_blank">
    <i class="material-icons">search</i>
  </a>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SearchFloatButton extends Vue {}
</script>

<style lang="scss" scoped>
  .search-float-btn {
    align-items: center;
    background: #20a8d8;
    border-radius: 50% !important;
    bottom: 90px;
    box-shadow: 2px 2px 3px #999;
    display: flex;
    height: 40px;
    justify-content: center;
    left: 30px;
    position: fixed;
    right: auto;
    text-align: center;
    width: 40px;
    z-index: 10;

    @media (max-width: 768px) {
      bottom: 70px;
      left: 15px;
    }
  }

  .search-float-btn:focus, .search-float-btn:hover {
      outline: none;
      text-decoration: none;
  }

  .search-float-btn i {
      color: #fff;
      font-size: 1.2rem;
  }

  html[dir="ltr"] {
    .search-float-btn {
      left: auto;
      right: 30px;

      @media (max-width: 768px) {
        bottom: 70px;
        right: 15px;
      }
    }
  }
</style>
